import { render } from "./EndocrinologiePage.vue?vue&type=template&id=ddb70e72"
import script from "./EndocrinologiePage.vue?vue&type=script&lang=js"
export * from "./EndocrinologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__